import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { images } from '../data/content';
import { CtaButton } from './CtaButton';
import { Mechanism } from './Mechanism';
import { LeafSprig } from './decor/LeafSprig';
export function Hero() {
  const reduce = useReducedMotion();
  return <section id="top" className="relative overflow-hidden bg-cream" data-id="element-72" data-mp="4m8lmajdinjv">
      <LeafSprig className="pointer-events-none absolute -left-4 bottom-10 hidden h-48 w-20 -rotate-12 text-sage lg:block" data-id="element-73" data-mp="4jvyzk2o7p0h" />
      <div className="mx-auto grid max-w-content gap-x-14 gap-y-6 px-5 pb-12 pt-8 sm:px-8 sm:gap-y-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.12fr)] lg:pb-24 lg:pt-16" data-id="element-74" data-mp="x9urjpg2q49w">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-75" data-mp="sd4aozwg34nf">
          <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-terra-deep" data-id="element-76" data-mp="nboov5mg0u3z">When your child’s worry takes over…</p>
          <h1 className="mt-5 font-display text-[46px] leading-[1.02] text-ink sm:text-[62px] lg:text-[70px]" data-id="element-77" data-mp="3cz5weevm861x">
            Know What to Say.
            <br data-id="element-78" data-mp="3j9ka79gurdf2" />
            <span className="italic text-sage-deep" data-id="element-79" data-mp="3j9ty8ric7ai4">Know What to Do.</span>
          </h1>
        </div>

        <motion.div initial={reduce ? false : {
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-80" data-mp="3o73no75q7m5y">
          <img src={images.bundle} alt="The Worry-to-Brave Toolkit: the main guide, six practical volumes and five bonus resources" className="-mx-2 w-[calc(100%+1rem)] max-w-[640px] sm:mx-auto sm:w-full" data-id="element-81" data-mp="30h9bzsx583na" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-82" data-mp="2vies0nnfw91l">
          <p className="max-w-xl text-[17px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-83" data-mp="2vgu2jcfzfgal">
            Help your child move from endless “what ifs,” reassurance and avoidance toward practical coping skills, brave steps
            and growing confidence — with simple, ready-to-use tools for the moments you need them most.
          </p>

          <div className="mt-6 border-t border-cream-line pt-5 sm:mt-8 sm:pt-6" data-id="element-84" data-mp="nat8vfsf4smt">
            <p className="font-display text-[22px] uppercase tracking-[0.05em] text-ink" data-id="element-85" data-mp="ic88ngd628yd">The Worry-to-Brave Toolkit</p>
            <p className="mt-1 text-[15px] font-medium text-ink-soft" data-id="element-86" data-mp="ddnf1zsf6niw">6 Practical Volumes + 5 Ready-to-Use Bonuses</p>
            <Mechanism className="mt-4" data-id="element-87" data-mp="1azumdhg3ytyy" />
          </div>

          <div className="mt-7 sm:mt-8" data-id="element-88" data-mp="161t1cqz4gkku">
            <CtaButton className="w-full sm:w-auto" data-id="element-89" data-mp="162ufx5fcjp7b">Get Instant Access</CtaButton>
            <p className="mt-4 text-[13px] text-ink-mute" data-id="element-90" data-mp="111yc0ruzw31w">Instant Digital Access • Delivered by Email • 7-Day Guarantee</p>
          </div>
        </div>
      </div>
    </section>;
}